import {
  FETCH_SPECIFICATIONS,
  FETCH_SPECIFICATIONS_START,
  FETCH_SPECIFICATIONS_SUCCESS,
  FETCH_SPECIFICATIONS_ERROR,
  IMPORT_SPECIFICATIONS_SUMMARY,
  IMPORT_SPECIFICATIONS_SUMMARY_START,
  IMPORT_SPECIFICATIONS_SUMMARY_SUCCESS,
  IMPORT_SPECIFICATIONS_SUMMARY_ERROR,
  UPDATE_SPECIFICATIONS,
  UPDATE_SPEC_SOURCES,
  UPDATE_EDIT_VALUE,
  UPDATE_SELECTED_REVISION,
  UPDATE_IMPORT_SKUS_LIST,
  CLEAR_EDIT_VALUE,
  TOGGLE_REVISION_DIALOG,
  TOGGLE_IMPORT_DIALOG,
  TOGGLE_HIDE_SPECIFICATIONS_TABLE,
  POST_SPECIFICATIONS,
  POST_SPECIFICATIONS_START,
  POST_SPECIFICATIONS_SUCCESS,
  POST_SPECIFICATIONS_ERROR,
  IMPORT_SPECIFICATION,
  IMPORT_SPECIFICATION_START,
  IMPORT_SPECIFICATION_SUCCESS,
  IMPORT_SPECIFICATION_ERROR,
} from './constants'
import {
  buildAsyncAction,
} from 'containers/Async/actions'


/* UI States */
const clearEditValue = () => ({ type: CLEAR_EDIT_VALUE })
const updateEditValue = (value) => ({ type: UPDATE_EDIT_VALUE, value })
const updateSpecifications = (array) => ({ type: UPDATE_SPECIFICATIONS, array })
const updateImportSkusList = (array) => ({ type: UPDATE_IMPORT_SKUS_LIST, array })
const updateSpecSources = (value) => ({ type: UPDATE_SPEC_SOURCES, value })
const updateSelectedRevision = (value) => ({ type: UPDATE_SELECTED_REVISION, value })
const toggleRevisionDialog = (value) => ({ type: TOGGLE_REVISION_DIALOG, value })
const toggleImportDialog = (value) => ({ type: TOGGLE_IMPORT_DIALOG, value })
const hideSpecificationsTable = (value) => ({ type: TOGGLE_HIDE_SPECIFICATIONS_TABLE, value })

/* Async Calls */
const fetchSpecifications = (id, specs) => ({ type: FETCH_SPECIFICATIONS, id, specs })
const fetchSpecificationsStart = () => ({ type: FETCH_SPECIFICATIONS_START })
const fetchSpecificationsSuccess = () => ({ type: FETCH_SPECIFICATIONS_SUCCESS })
const fetchSpecificationsError = (error) => ({ type: FETCH_SPECIFICATIONS_ERROR, error })
const startFetchSpecificationsAsync = buildAsyncAction(
  FETCH_SPECIFICATIONS_START,
  [FETCH_SPECIFICATIONS_SUCCESS, FETCH_SPECIFICATIONS_ERROR]
)

const postSpecifications = (id, specs) => ({ type: POST_SPECIFICATIONS, id, specs })
const postSpecificationsStart = () => ({ type: POST_SPECIFICATIONS_START })
const postSpecificationsSuccess = () => ({ type: POST_SPECIFICATIONS_SUCCESS })
const postSpecificationsError = (error) => ({ type: POST_SPECIFICATIONS_ERROR, error })
const startPostSpecificationsAsync = buildAsyncAction(
  POST_SPECIFICATIONS,
  POST_SPECIFICATIONS_START,
  [POST_SPECIFICATIONS_SUCCESS, POST_SPECIFICATIONS_ERROR]
)

const importSpecificationsSummary = (id) => ({ type: IMPORT_SPECIFICATIONS_SUMMARY, id })
const importSpecificationsSummaryStart = () => ({ type: IMPORT_SPECIFICATIONS_SUMMARY_START })
const importSpecificationsSummarySuccess = () => ({ type: IMPORT_SPECIFICATIONS_SUMMARY_SUCCESS })
const importSpecificationsSummaryError = (error) => ({ type: IMPORT_SPECIFICATIONS_SUMMARY_ERROR, error })

const importSpecification = (id) => ({ type: IMPORT_SPECIFICATION, id })
const importSpecificationStart = () => ({ type: IMPORT_SPECIFICATION_START })
const importSpecificationSuccess = () => ({ type: IMPORT_SPECIFICATION_SUCCESS })
const importSpecificationError = (error) => ({ type: IMPORT_SPECIFICATION_ERROR, error })

export {
  clearEditValue,
  updateEditValue,
  updateSpecifications,
  updateImportSkusList,
  updateSpecSources,
  updateSelectedRevision,
  toggleRevisionDialog,
  toggleImportDialog,
  hideSpecificationsTable,
  fetchSpecifications,
  fetchSpecificationsStart,
  fetchSpecificationsSuccess,
  fetchSpecificationsError,
  startFetchSpecificationsAsync,
  postSpecifications,
  postSpecificationsStart,
  postSpecificationsSuccess,
  postSpecificationsError,
  startPostSpecificationsAsync,
  importSpecificationsSummary,
  importSpecificationsSummaryStart,
  importSpecificationsSummarySuccess,
  importSpecificationsSummaryError,
  importSpecification,
  importSpecificationStart,
  importSpecificationSuccess,
  importSpecificationError
}
